import React, { useState } from 'react';
import { Box, Paper, Typography, Button, Alert, CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import api from '../axiosConfig';
import { downloadBlob } from './exportUtils';
 
export const SupplierExport = ({ setMessage = () => {}, setMessageType = () => {} }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);
 
  const handleExport = async () => {
    setIsProcessing(true);
    setError(null);
 
    try {
      const response = await api.get('/csv/export/suppliers', { responseType: 'blob' });
      downloadBlob(response, 'suppliers_export.csv');
      setMessageType('success');
      setMessage('Supplier data exported.');
    } catch (err) {
      console.error('Export error:', err);
      setError(err.response?.data?.error || 'An error occurred during export');
      setMessageType('error');
      setMessage('Error exporting supplier data. Please try again.');
    } finally {
      setIsProcessing(false);
    }
  };
 
  return (
    <Paper elevation={3} sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5">Suppliers Export</Typography>
      </Box>
 
      <Alert severity="info" sx={{ mb: 3 }}>
        <Typography variant="body2">
          Exports contact details, VAT status and account references for every supplier.
          Note: there's no matching Supplier import on the backend yet (see caveat below),
          so this file is for your records/backup rather than a round-trip re-import.
        </Typography>
      </Alert>
 
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
 
      <Button
        startIcon={isProcessing ? <CircularProgress size={20} /> : <DownloadIcon />}
        variant="contained"
        onClick={handleExport}
        disabled={isProcessing}
      >
        {isProcessing ? 'Preparing export...' : 'Export Suppliers CSV'}
      </Button>
    </Paper>
  );
};
 
export default SupplierExport;